
import { combineReducers } from "@reduxjs/toolkit";
import authReducer from '../slices/authSlice';
import fingerprintReducer from '../slices/fingerPrintSlice';
import imageReducer from '../slices/imageSlice'
import signatureReducer from '../slices/signatureSlice'
import  openCamReducer from '../slices/openCamSlice'
const rootReducer = combineReducers({
    auth: authReducer,
    fingerprint: fingerprintReducer,
    profileimage:imageReducer,
    singature:signatureReducer,
    camera: openCamReducer
});

export default rootReducer;
